import moment from "moment";
import { CleaningAction } from "./action";
import { CleaningDateList, CleaningState, cleaningState } from "./state";
import { BinInfo } from "../staticInfo/state";

export function cleaningReducer(
  state: CleaningState = cleaningState,
  action: CleaningAction
): CleaningState {
  switch (action.type) {
    case "@@cleaningState/initCleaningDateList":
      return {
        ...state,
        cleaningDateList: action.cleaningDateList,
      };
    case "@@cleaningState/initCleaningRouteListAction":
      return {
        ...state,
        cleaningRouteList: action.cleaningRouteList,
      };

    case "@@cleaningState/initCleaningDetailRouteList":
      return {
        ...state,
        cleaningDetailRouteList: action.cleaningDetailRouteList,
      };
    case "@@cleaningState/initCleaningDetailPhotoAction":
      return {
        ...state,
        cleaningDetailImageList: action.cleaningDetailImageList,
      };

    case "@@cleaningState/changeCleaningBinInfoAction":
      return {
        ...state,
        binInfo: action.binInfo!,
      };

    case "@@cleaningState/ChangeAttendaceDateTimeAction":
      return {
        ...state,
        selectedCleaningDetail: {
          ...state.selectedCleaningDetail,
          attendance_date: moment(parseInt(action?.date)).local()
          
          
        
        },
      };

    case "@@cleaningState/ChangeCleaningDateTimeAction":
      return {
        ...state,
        selectedCleaningDetail: {
          ...state.selectedCleaningDetail,
          update_date: moment.utc(action.date),
        },
      };

    case "@@cleaningState/ChangeClickCleaningDateFolderAction":
      return {
        ...state,
        clickDate: action.clickDate,
      };

    case "@@cleaningState/initCleaningImageTypeListAction":
      return {
        ...state,
        cleaningImageType: action.imagetypeList,
      };

    case '@@cleaningState/changePeopleCounterNumberAction':
       return {
        ...state,
        selectedCleaningDetail:{
          ...state.selectedCleaningDetail,
          people_counter_number:action.people_counter_number
        }
        
      };

    case "@@cleaningState/selectedCleaningDetailRouteAction":
      const binInfo: BinInfo = {
        label: action.cleaningDetail.bin_full_name,
        value: action.cleaningDetail.bin_id,
      };
      return {
        ...state,
        selectedCleaningDetail: {
          ...state.selectedCleaningDetail,
          cleaning_detail_route_id:
          action.cleaningDetail.cleaning_detail_route_id,
          cleaning_id: action.cleaningDetail.cleaning_id,
          bin_id: action.cleaningDetail.bin_id,
          bin_full_name: action.cleaningDetail.bin_full_name,
          attendance_date: moment.utc(parseInt(action.cleaningDetail.attendance_date as string)).local(),
          update_date: moment.utc(parseInt(action.cleaningDetail.update_date as string)).local(),
          sequence: action.cleaningDetail.sequence,
          time_start: action.cleaningDetail.time_start,
          time_end: action.cleaningDetail.time_end,
          value: action.cleaningDetail.value,
          people_counter_number:action.cleaningDetail.people_counter_number,
          create_date:action.cleaningDetail.create_date
          
        },
        binInfo: binInfo,
      };

    default:
      return state;
  }
}
